import React from 'react';

export default function Skills() {
    return (
        <div>
            <h1>Skills</h1>
        </div>
    );
}
